module.exports = __webpack_public_path__ + "static/media/mobile_dicero_page_area01_img_cn.80025125.png";